import { Component } from 'react';
import { connect } from 'react-redux';

import {
  convertStringToInteger,
  currencyFormat
} from 'common/helpers/numberHelper';
import { addCartItem } from 'redux/cart/actions';

// eslint-disable-next-line import/no-cycle
import AddToCart from './AddToCart';
import CompareAtPrice from './CompareAtPrice';
import LoginToPurchase from './LoginToPurchase';
import SalePrice from './SalePrice';

class Variant extends Component {
  constructor(props) {
    super(props);
    let quantity = 12;
    if (
      props.product.security &&
      props.product.security.availableTo === 'Allocation' &&
      props.product.allocations &&
      props.product.allocations[0]
    ) {
      quantity = props.product.allocations[0].minQuantity;
    }
    this.state = {
      quantity,
      error: null,
      selectedVariant: props.product.variants[0]
    };
  }

  submitForm = (e) => {
    const { props, state } = this;
    e.preventDefault();
    const { selectedVariant } = this.state;
    if (state.quantity === '' || Number.isNaN(state.quantity)) {
      this.setState({ error: 'Invalid Quantity' });
    } else if (convertStringToInteger(state.quantity) < 1) {
      this.setState({ error: 'Invalid Quantity' });
    } else {
      const item = {
        quantity: convertStringToInteger(state.quantity),
        sku: selectedVariant.sku
      };
      props.addCartItem(item, props.analytics);
    }
  };

  handleQuantity = (e) => {
    const input = e.target.value;
    const quantity = input.replace(/[^0-9]/g, '');
    this.setState({ quantity, error: null });
  };

  handleVariant = (e) => {
    const { props } = this;
    const selectedVariant = props.product.variants.find(
      (variant) => variant.id === e.target.value
    );
    this.setState({ selectedVariant });
  };

  render() {
    const { product, hidePrice, settings, analytics } = this.props;
    const { selectedVariant } = this.state;
    const { quantity, error } = this.state;
    if (product.webStatus !== 'Available') {
      return null;
    }
    if (product.type !== 'Wine') {
      return (
        <AddToCart
          product={product}
          hidePrice={hidePrice}
          settings={settings}
          key={product.id}
          analytics={analytics}
        />
      );
    }
    if (!product.variants || product.variants.length === 0) {
      return null;
    }
    if (
      product.security &&
      product.security.availableTo !== 'Public' &&
      !product.security.isValidUser
    ) {
      return <LoginToPurchase product={product} />;
    }
    let minQty = 0;
    let maxQty = 1000;
    if (
      product.security &&
      product.security.availableTo === 'Allocation' &&
      product.allocations &&
      product.allocations[0]
    ) {
      minQty = product.allocations[0].minQuantity;
      maxQty =
        product.allocations[0].maxQuantity +
        product.allocations[0].additionalGrant -
        product.allocations[0].quantityPurchased;
    }
    if (maxQty - minQty <= 0) {
      return null;
    }
    if (maxQty < 12) {
      return null;
    }
    return (
      <form
        action=""
        onSubmit={this.submitForm}
        className="c7-product__variant"
      >
        {!hidePrice && (
          <div className="c7-product__variant__price">
            <CompareAtPrice variant={selectedVariant} settings={settings} />
            <SalePrice variant={selectedVariant} settings={settings} />
          </div>
        )}
        {product.variants.length > 1 && (
          <select
            className="c7-product__variant__select"
            name="variantId"
            value={selectedVariant.id}
            onChange={this.handleVariant}
            aria-label={`Quantity for ${product.title}`}
          >
            {renderOptionArray(product.variants, settings)}
          </select>
        )}
        {error && (
          <span className="c7-product__error" aria-describedby="qtyerror">
            Error: {error}
          </span>
        )}
        <div className="c7-product__variant__add-to-cart">
          {renderCaseInputButton(
            quantity,
            this.handleQuantity,
            minQty,
            maxQty,
            error
          )}

          <button
            className="c7-button"
            type="submit"
            aria-label={product.title}
          >
            Add case
          </button>
        </div>
      </form>
    );
  }
}

const renderCaseInputButton = (
  quantity,
  handleQuantity,
  minQty,
  maxQty,
  error
) => {
  let count = 10;
  if (maxQty < 120) {
    count = Math.floor(maxQty / 12);
  }
  const optionArray = [];
  for (let i = 1; i <= count; i += 1) {
    optionArray.push(i);
  }
  let describedby;
  if (error) {
    describedby = { 'aria-describedby': 'qtyerror' };
  }
  return (
    <label htmlFor="quantity">
      <select
        name="quantity"
        className="c7-product__variant__add-to-cart__select"
        value={quantity}
        onChange={handleQuantity}
        inputMode="numeric"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...describedby}
      >
        {optionArray.map((option) => (
          <option key={option * 12} value={option * 12}>
            {option * 12}
          </option>
        ))}
      </select>
    </label>
  );
};

const renderOptionArray = (variants, settings) =>
  variants.map((variant) => (
    <option key={variant.id} value={variant.id}>
      {variant.title} {currencyFormat(variant.addToCartPrice, settings)}
    </option>
  ));

export default connect(null, { addCartItem })(Variant);
